import appConstants from "../../../../../../appConstants";

export const getUnassignedPickupDetails = (pickups) => {
  return [
    { label: "Pickups", value: pickups.length },
    {
      label: "PSE",
      value: pickups.reduce((pse, pickup) => pse + pickup.pse, 0),
    },
    {
      label: "Weight",
      value: pickups.reduce((weight, pickup) => weight + pickup.weight, 0),
    },
  ];
};

export const getDriverDetails = (driverRoutes) => {
  const driverDetails = {
    pendingDeliveries: 0,
    returns: 0,
    pendingPickups: 0,
    missedApts: 0,
    trailerName: "",
    pse: 0,
    weight: 0,
  };

  const driverPendingPickups = [];

  driverRoutes.forEach((route) => {
    driverDetails.trailerName = route.trailerName;
    driverDetails.missedApts += route.numServiceViolations;
    route.stops.forEach((stop) => {
      if (stop.isStopCompleted) {
        if (stop.stopType === appConstants.STOP_TYPE.Pickup) {
          driverDetails.pse += getShipmentsPSE(stop.shipments);
          driverDetails.weight += getShipmentsWeight(stop.shipments);
        } else if (
          stop.stopType === appConstants.STOP_TYPE.Delivery &&
          stop.shipments.some((shipment) => shipment.returnCode)
        ) {
          const returnedShipments = stop.shipments.filter(
            (shipment) => shipment.returnCode
          );
          driverDetails.pse += getShipmentsPSE(returnedShipments);
          driverDetails.weight += getShipmentsPSE(returnedShipments);
          driverDetails.returns++;
        }
      } else if (stop.stopType === appConstants.STOP_TYPE.Delivery) {
        driverDetails.pse += stop.pse || 0;
        driverDetails.weight += stop.weight || 0;
        driverDetails.pendingDeliveries++;
      } else if (stop.stopType === appConstants.STOP_TYPE.Pickup) {
        driverDetails.pendingPickups++;
        driverPendingPickups.push({
          pickupNumber: stop.pickupNumber,
          name: stop.name,
        });
      }
    });
  });

  const driverStopDetails = [
    { label: "Pending Del", value: driverDetails.pendingDeliveries },
    { label: "Returns", value: driverDetails.returns },
    { label: "Pending Pck", value: driverDetails.pendingPickups },
    { label: "Missed Apts", value: driverDetails.missedApts },
    { label: "Trailer Type", value: driverDetails.trailerName }, //As per mock we are displaying trailerName as trailerType
    { label: "PSE", value: driverDetails.pse },
    { label: "Weight", value: driverDetails.weight },
  ];
  return { driverStopDetails, driverPendingPickups };
};

const getShipmentsPSE = (shipments) =>
  shipments.reduce((pse, shipment) => pse + (shipment.pse || 0), 0);
const getShipmentsWeight = (shipments) =>
  shipments.reduce((weight, shipment) => weight + (shipment.weight || 0), 0);

const filterPickupsExcluding = (unassignedPickups, excludedPickupNumbers) =>
  unassignedPickups.filter(
    (pickup) => !excludedPickupNumbers.includes(pickup.pickupNumber)
  );

export const shouldReconcileLassoSelection = (prevProps, nextProps) =>
  nextProps.unassignedPickups !== prevProps.unassignedPickups ||
  Boolean(nextProps.isNewLasso) !== Boolean(prevProps.isNewLasso);

export const buildLassoSelectionStateUpdate = (
  unassignedPickups,
  isNewDrawCycle,
  currentExcludedPickupNumbers
) => {
  const excluded = isNewDrawCycle ? [] : currentExcludedPickupNumbers;
  const selectedPickups = filterPickupsExcluding(unassignedPickups, excluded);
  return {
    selectedPickups,
    ...(isNewDrawCycle ? { selectedPickupsToExclude: [] } : {}),
  };
};
